import { CloudinaryImages } from "@ng-mw/framework-core"

function snapWidthToNearest(width: number) {
    // TODO finetune snapping values?
    const smallSnap = 8
    const bigSnap = 100
    if (width > 257) {
        return Math.ceil(width / bigSnap) * bigSnap
    }
    return Math.ceil(width / smallSnap) * smallSnap
}

export interface ViewportScaledImageConf {
    minWidth?: number
    maxWidth: number
    aspect: number
    ratio?: number
    cropMode?: string
    dprMode?: number
}

const getViewportScaledImageConf = ({
    minWidth = 0,
    maxWidth = Infinity,
    aspect = 1, // 2/1 = 2 | 16/9 = 1.7777 etc
    ratio = 1, // 0.5 if only 50% of viewport width
    cropMode = CloudinaryImages.cropMode.FILL,
    dprMode = CloudinaryImages.dprMode.DETECT,
}: ViewportScaledImageConf) => {
    const vw = window.innerWidth
    const width = snapWidthToNearest(Math.max(minWidth, Math.min(vw * ratio, maxWidth)))
    const height = Math.ceil(width / aspect)
    return {
        width,
        height,
        cropMode,
        dprMode,
    }
}

const { cropMode, dprMode } = CloudinaryImages

export { getViewportScaledImageConf, cropMode, dprMode }

const MenyImageConfig = Object.freeze({
    ProductDetails: {
        width: 160,
        height: 160,
        cropMode: cropMode.PAD,
    },
})

export default MenyImageConfig
